export default __webpack_public_path__ + "d4.png";